import { createContext } from 'react';

type PortalContextType = {
  widgetLayoutContainer: string;
  portalId?: string;
  widgetContainerId?: string;
};

export const PortalContext = createContext<PortalContextType | null>(null);
